import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { FINE_TYPES_MODEL } from '../../pages/Dashboard/Traffic/FineTypes/Model/Model';


/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

/**
 * TrafficOutlet
 * This component provides context for the Traffic module.
 * It initializes a local state based on the fine types model,
 * and exposes both the state and its setter to all nested routes
 * through React Router's Outlet context.
 */
const TrafficOutlet = () => {
    /** 
     * @state fineType - stores the current fine type data model
     * @state setFineType - updates the fine type model
     */
    const [fineType, setFineType] = useState({ ...FINE_TYPES_MODEL });


    return (
        <>
            <Outlet
                context={{
                    fineType,
                    setFineType,
                }}
            />
        </>
    );
};

export default TrafficOutlet;
